<template>
  <b-container>
    <b-button size="sm" v-if="cargoPath.delivered == false" @click="modalOpen">
      <i class="tim-icons icon-pencil"> </i>
    </b-button>
    <b-button size="sm" v-else-if="cargoPath.delivered" @click="modalOpen">
      <b-icon icon="eye" aria-hidden="true"> </b-icon>
    </b-button>
    <b-modal
      size="lg"
      ref="openModal"
      class="filterDateModal"
      scrollable
      title="Detalhes do trajeto"
      @ok="modalOk()"
    >
      <div v-if="cargoPath">
        <!-- OriginStateId -->
        <b-form-group
          :label="$t('tracking.cargo.originState')"
          label-for="OriginStateId"
        >
          <state-dropdown
            id="OriginStateId"
            :states="optionsState"
            :state-id="parseInt(cargoPath.originStateId)"
            :changeId.sync="cargoPath.originStateId"
            :changeAbrev.sync="cargoPath.originStateAbrev"
          >
          </state-dropdown>
          <span class="text-danger" v-if="hasError">
            {{ "Estado de origem é obrigatório" }}
          </span>
        </b-form-group>

        <!-- OriginCityId -->
        <b-form-group
          :label="$t('tracking.cargo.originCity')"
          label-for="OriginCityId"
        >
          <city-dropdown
            id="OriginCityId"
            :state-id="parseInt(cargoPath.originStateId)"
            :city-id="cargoPath.originCityId"
            :changeData.sync="cargoPath.originCityId"
            :changeName.sync="cargoPath.originCityName"
            :readonly="edit"
          >
          </city-dropdown>
          <span class="text-danger" v-if="hasError">
            {{ "Cidade de origem é obrigatório" }}
          </span>
        </b-form-group>
        <!-- DestinationStateId -->
        <b-form-group
          :label="$t('tracking.cargo.destinationState')"
          label-for="DestinationStateId"
        >
          <state-dropdown
            id="DestinationStateId"
            :states="optionsState"
            :state-id="parseInt(cargoPath.destinationStateId)"
            :changeId.sync="cargoPath.destinationStateId"
            :changeAbrev.sync="cargoPath.destinationStateAbrev"
          >
          </state-dropdown>
          <span class="text-danger" v-if="hasError">
            {{ "Estado de destino é obrigatório" }}
          </span>
        </b-form-group>
        <!-- DestinationCityId -->
        <b-form-group
          :label="$t('tracking.cargo.destinationCity')"
          label-for="DestinationCityId"
        >
          <city-dropdown
            id="DestinationCityId"
            :state-id="parseInt(cargoPath.destinationStateId)"
            :city-id="cargoPath.destinationCityId"
            :changeData.sync="cargoPath.destinationCityId"
            :changeName.sync="cargoPath.destinationCityName"
            :readonly="edit"
          >
          </city-dropdown>
          <span class="text-danger" v-if="hasError">
            {{ "Cidade de destino é obrigatório" }}
          </span>
        </b-form-group>
        <!-- NfeNumber -->
        <b-form-group label="Nf-e" label-for="NfeNumber">
          <b-form-input
            id="NfeNumber"
            type="text"
            placeholder="Nf-e"
            v-model="cargoPath.nfeNumber"
            :readonly="edit"
          />
        </b-form-group>

        <!-- CteNumber -->
        <b-form-group label="CT-e" label-for="CteNumber">
          <b-form-input
            id="CteNumber"
            type="text"
            placeholder="CT-e"
            v-model="cargoPath.cteNumber"
            :readonly="edit"
          />
        </b-form-group>
        <!-- ManifestNumber -->
        <b-form-group label="Manifesto" label-for="ManifestNumber">
          <b-form-input
            id="ManifestNumber"
            type="text"
            placeholder="Manifesto"
            v-model="cargoPath.manifestNumber"
            :readonly="edit"
          />
        </b-form-group>
        <!-- CiotNumber -->
        <b-form-group label="CIOT" label-for="CiotNumber">
          <b-form-input
            id="CiotNumber"
            type="text"
            placeholder="CIOT"
            v-model="cargoPath.ciotNumber"
            :readonly="edit"
          />
        </b-form-group>
        <!-- freightContract -->
        <b-form-group label="Contrato de frete" label-for="FreightContract">
          <b-form-input
            id="FreightContract"
            type="text"
            placeholder="Contrato de frete"
            v-model="cargoPath.freightContract"
            :readonly="edit"
          />
        </b-form-group>
        <!-- valor do frete -->
        <b-form-group label="Valor do frete" label-for="FreightCost">
          <base-input-numeric
            id="FreightCost"
            placeholder="Valor do frete"
            :value.sync="cargoPath.freightCost"
            :readonly="edit"
          >
          </base-input-numeric>
        </b-form-group>
        <!-- deliveryDate -->
        <b-form-group label="Data da entrega" label-for="DateAttendance">
          <b-form-input
            type="date"
            id="DateAttendance"
            :placeholder="$t('tracking.cargo.dateAttendance')"
            v-model="cargoPath.dateDelivery"
            :readonly="edit"
          />
        </b-form-group>
        <!-- deliveryHour -->
        <b-form-group label="Hora da entrega" label-for="HourAttendance">
          <b-form-input
            type="time"
            id="HourAttendance"
            :placeholder="$t('tracking.cargo.timeAttendance')"
            v-model="cargoPath.hourDelivery"
            :readonly="edit"
          />
        </b-form-group>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <div class="right">
          <!-- <b-button variant="green" @click="canEdit" v-if="readonly && edit">
            Editar
          </b-button> -->
          <b-button
            v-if="cargoPath.delivered == false"
            class="ml-2"
            variant="green"
            @click="ok()"
          >
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
import AwesomeMask from "awesome-mask";
export default {
  name: "CargoPathModalEdit",
  components: {
    CityDropdown: () => import("@/components_rms/System/city/CityDropdown.vue"),
    "state-dropdown": () =>
      import("@/components_rms/System/state/StateDropdown.vue"),
    BaseInputNumeric: () => import("../../base/BaseInputNumeric.vue"),
  },
  directives: {
    mask: AwesomeMask,
  },
  props: {
    cargoPath: Object,
    optionsState: Array,
    hasError: Boolean,
    carga: Object,
    readonly: Boolean,
  },
  created() {
    this.cargoPath.dateDelivery = this.dateToString(this.cargoPath.dateDelivery);
    if (this.cargoPath.delivered) this.edit = true;
    else this.edit = false;
  },
  computed: {},
  data() {
    return {
      edit: true,
    };
  },
  methods: {
    modalOk() {
      this.$emit("refresh", this.cargoPath);
    },
    modalOpen() {
      this.$refs.openModal.show();
    },
    dateToString(date) {
      if (date) {
        if (date != null && date != "") {
          return date.split("T")[0];
        }
      }
      return null;
    },
    canEdit() {
      this.edit = false;
    },
  },
};
</script>
